import React from 'react'

export const Login = () => {
  return (
    <div>Login</div>
  )
}
